import React from 'react';
import { Field, Input } from '@chakra-ui/react';

type CurrencyFieldProps = {
  value: string;
  onChange: (value: string) => void;
  errors?: string[];
  label?: string;
};

const CurrencyField = ({ value, onChange, errors, label }: CurrencyFieldProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const numericValue = parseInt(inputValue.replace(/[^0-9]/g, ''), 10);
    const number = isNaN(numericValue) ? 0 : numericValue;

    const formattedValue = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(number / 100);

    onChange(formattedValue);
  };

  return (
    <Field.Root invalid={!!errors}>
      <Field.Label>{label}</Field.Label>
      <Input
        value={value}
        onChange={handleChange}
        variant="subtle"
        placeholder="R$ 0,00"
        required
      />
      {errors?.map((error, index) => (
        <Field.ErrorText key={index}>{error}</Field.ErrorText>
      ))}
    </Field.Root>
  );
};

export default CurrencyField;